import React from "react";
import { MasonryLayoutIcon, SquaredLayoutIcon, ContainerLayoutIcon } from '@dmi-mch/icons';

var layouOptions = function layouOptions(labelObj) {
  var options = [{
    key: 'masonry',
    value: 'MASONRY',
    text: labelObj.labelsForm.translate('MASONRY'),
    icon: /*#__PURE__*/React.createElement(MasonryLayoutIcon, null)
  }, {
    key: 'squared',
    value: 'SQUARED',
    text: labelObj.labelsForm.translate('SQUARED'),
    icon: /*#__PURE__*/React.createElement(SquaredLayoutIcon, null)
  }, {
    key: 'container',
    value: 'CONTAINER',
    text: labelObj.labelsForm.translate('CONTAINER'),
    icon: /*#__PURE__*/React.createElement(ContainerLayoutIcon, null)
  }];
  return options;
};

export default layouOptions;